module.exports = __webpack_public_path__ + "static/media/customer-3.b764e948.jpg";